import { FC, useState, useEffect } from "react"
import { useQueryClient } from "react-query"
import { Formik, Form, FormikValues } from "formik"
import * as Yup from 'yup'
import {
  FormikFileUpload,
  StatusErrorMessage,
  ApplicationFileDownload,
  FormikNotesArea
} from "../../../../../components/widgets"

import { doFormSubmit,processNoteValues } from "../../../../../components/helpers"

import { cloneDeep, pickBy} from "lodash"
import { DLMROI, submitDLMPhase_3_1_4_2 } from "../../../../core/doclabel"

import { SubmitButtonRow } from "../../../../../components/layout"

const DLM_ROI_SELECTED_FIELDS = [
  'roiId',
  'roiAttachmentId',
]

const initSubmitActualROIValues = {
  roiModels: [],
  note: '',
  noteAttachments: [],
}

const schema = Yup.object({
  roiModels: Yup.array().of(
    Yup.object().shape({
      roiId: Yup.number().integer().label('ROI Id'),
      roiAttachmentId: Yup.number().integer().moreThan(0,'ROI required').required().label('ROI Attachment'),
      roiAttachmentIdAttachmentName: Yup.string().trim(),
    })
  ).min(1, 'ROI Required').required(),
  note: Yup.string().trim().label('Note'),
  noteAttachments: Yup.array(),
})

type Props = {
  id: number
  appID: number
  rois: Array<DLMROI>
  doClose: Function
}

const SubmitActualROIForm: FC<Props> = ({id, appID, rois, doClose}) => {
  const queryClient = useQueryClient()
  const [initValues, setInitValues] = useState(initSubmitActualROIValues);

  useEffect(() => {
    if (! (rois && rois.length > 0)) return;
    let _inits = cloneDeep(initValues);

    Object.assign(_inits, { roiModels: rois.map( roi => {
        return {
            roiId: roi.id,
            roiAttachmentId: 0,
            roiAttachmentIdAttachmentName: ''
        };
    })});
    setInitValues(_inits);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rois]);


  const doSubmit = async (values: any, actions: FormikValues) => {

    const { setStatus, setSubmitting } = actions;
    const _models = values.roiModels.map( (model: any) => pickBy(model, (value, key) => (value && (DLM_ROI_SELECTED_FIELDS.indexOf(key) > -1))));

    const payload = {
      ...pickBy(values, (value, key) => (value && (! key.match(/(note|AttachmentName|roiModels)$/i)))),
      siteApplicationid: id,
      roiModels: _models
    };

    processNoteValues(values, payload);
    
    await doFormSubmit(submitDLMPhase_3_1_4_2, payload, setStatus, setSubmitting, () => {
      queryClient.invalidateQueries(['DLMAPPLICATIONS-LIST', { lastpath: 'label-applications-list'}]);
      queryClient.invalidateQueries(['DLMAPPLICATIONS-LIST', { listmode: 'own'} ]);
      queryClient.invalidateQueries(['DLMAPPLICATION-LOAD', { dlmappid: appID } ]);
      doClose();
    });
  }

  return(
  <>
  <Formik
    initialValues={initValues}
    validationSchema={schema}
    enableReinitialize={true}
    onSubmit={doSubmit}
  >
    {({status, validateField}) => (
    <>
    <Form id='kt_doclabel_submitresponse_form' className='form' noValidate>
      <div
        className='d-flex flex-column p-2'
      >
        <div className="fw-bold fs-6 mb-2">Site ROI:</div>
        <div className="mh-250px overflow-auto pe-4">        
          {rois.map((roiModel: any, idx: number) => (
          <div key={`setROIrow_${idx}`} className="row mb-4">
            <FormikFileUpload
              size="8"
              label={`[${roiModel?.cbRef ? roiModel.cbRef : roiModel.no}] ${roiModel.projectName}`}
              name={`roiModels.${idx}.roiAttachmentId`}
              acceptFiles="UserFileFormats"
              required={true}
              subTitle="Upload actual ROI here."
              onUpdateFunc={ () => {
                validateField('roiModels');
              }}
            />

            <div className="col-4">
              { roiModel.signedROIFile &&
              <>
              <div className="text-muted fs-7">Signed ROI</div>
              <ApplicationFileDownload file={roiModel.signedROIFile} />
              </>
              }
            </div>
          </div>
          ))
          }
        </div>
        <FormikNotesArea />
        <StatusErrorMessage status={status} />
        <SubmitButtonRow doClose={doClose} />
      </div>
    </Form>
    </>
    )}
  </Formik>
  </>
  )
}

export { SubmitActualROIForm }